module.exports = __webpack_public_path__ + "img/sld_scb_6_t1_green.8740164b.svg";